(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3278],{

/***/ 39903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/United-Arab-Emirates-Flag.26465ee4.svg","height":600,"width":1200});

/***/ }),

/***/ 56994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/cart.fe10664e.svg","height":24,"width":24});

/***/ }),

/***/ 92820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/cross-sign.ebc37022.png","height":10,"width":10,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAGFBMVEUAAABMaXEAAAAAAAAAAAAAAAAAAAAAAADtSWCRAAAAB3RSTlOVAIijewLDXiOIQgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADFJREFUCJkVxrcNADAQxDDp0+2/sWFW5HDXOjpopZHMpEUnKWV/xsVKVRDSSpprXbkHHUoAy07cpgEAAAAASUVORK5CYII="});

/***/ }),

/***/ 67350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/customer-service-agent.8d032ff9.svg","height":24,"width":24});

/***/ }),

/***/ 14842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/head-phone.8aadc922.png","height":25,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXH////////////////////////zsRG/AAAAB3RSTlMAOEEFYCBP1DBd0AAAAAlwSFlzAAALEgAACxIB0t1+/AAAAC9JREFUCJlFi8ENwEAMwgwk7D/yNa9KyPYHSG0H8MIKVAKjG0TzhxagPoacQ+d7PhCAAHPffiXAAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 20930:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/ind.c57723be.svg","height":600,"width":900});

/***/ }),

/***/ 1360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/logo-img.448f32e5.png","height":71,"width":45,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAICAMAAAAGL8UJAAAAJFBMVEX////+9fb809j6gY78xMr8oav7Z3j8tr77kp795+r+3OD7NEqRcZNwAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImRXKyRGAMAwEMG3sXNB/vwx6ixHY62K+IbWaMbt4apzQZ/8p8QELDwB0d7Z/FgAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 79138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/logo.faef84ed.png","height":50,"width":192,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEXPz8+kpKTX19fBwcG1tbXg4OCsrKy7u7u8hlN4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVQImWNgYGRgZ2FiZGBgYmRgZmNiYQUAASwAJ7yAzdAAAAAASUVORK5CYII="});

/***/ }),

/***/ 23997:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/map.5b2fb952.png","height":19,"width":14,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAKlBMVEU2NjY0NDQyMjJMaXEzMzM1NTU/Pz9PT09CQkI7OzsTExNJSUk2NjZQUFDF3alaAAAADnRSTlN8h04Ac2Y5mlmaAiedf65typUAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAwSURBVAiZBcGJAYAwDAOxs52kD7D/ukikYQew1Zxd5YW+cS3OqCxGyfsQmg6JKvcHFJYAxDsi8pIAAAAASUVORK5CYII="});

/***/ }),

/***/ 27573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/search.4f1ebec6.png","height":23,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAElBMVEVMaXH+GDL+GTP+GDL+GDL+GTM5kdOJAAAABnRSTlMAJ1VFdQ4iNeSKAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImS2KQQ4AMAjCCuj/v7zpxqWkKYDEzpKHCmRcG9yrXHkRqn+4yQEF9wAvkxGcFwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 57750:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/searchicon.5c349025.png","height":27,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAGFBMVEX////Kysrw8PDe3t7T09ONjY3BwcGvr68RgJxQAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVQImT2KQQ4AIAzCCkz9/4/N1NgLSSl8kjNKFWCBDExntbdq6Jb9PTYHiAA7jlq3BwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 59620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/senco-logo-main.e1f43903.png","height":60,"width":60,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEXmGzHmFSv1o6zoLEDlCyPrQ1XwdYLtXm3yhpLyjZn5y9B23ZKPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVQImSXKyQ0AMAgDQWzOpP+CE8Ava7Qi0JSdkYI+uLSBJLUF5RFNKPca8ROxseZvHhN7AJ5VlX4hAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 75494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/store-l.c2c65d40.svg","height":24,"width":24});

/***/ }),

/***/ 22760:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/us.74111a06.svg","height":16,"width":24});

/***/ }),

/***/ 23024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/whatsapp.caea4f03.png","height":21,"width":21,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAARVBMVEX////X8Nv///8XqCrp9+uP1Zii3Krg8+JMaXH///9ox3X8/vze8uD///8krTcusUAtsD/////P7dNEuVR+z4l2zIJJu1hJ9alWAAAAE3RSTlNwwGT7uP77sQAD+477Bfj8+13++6K4NgAAAAlwSFlzAAALEgAACxIB0t1+/AAAAD5JREFUCJkFwQcCwCAIALFzgqsL9P9PbYI2QmApmt1s5wW7+n05iM2SHhPk9K8UE96d+qwO1H3Mc2OMKBJVf12xAqAaDnIkAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 88584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/wishlist.9abe8f62.svg","height":24,"width":24});

/***/ }),

/***/ 76630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CurrencyInr = function(param) {
    var value = param.value;
    if (typeof value === "string" && value.includes(",")) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            children: [
                "AED ",
                value
            ]
        });
    }
    var formatter = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "AED"
    });
    var fraction = new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "AED",
        minimumFractionDigits: 0
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: parseFloat(value) % 1 == 0 ? fraction.format(parseFloat(value)) : formatter.format(parseFloat(value))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CurrencyInr);


/***/ }),

/***/ 70081:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/components/auth/auth-modal.tsx + 3 modules
var auth_modal = __webpack_require__(76565);
// EXTERNAL MODULE: ./src/components/auth/offer-modal.tsx + 2 modules
var offer_modal = __webpack_require__(87962);
// EXTERNAL MODULE: ./src/store/slices/helmet.ts
var slices_helmet = __webpack_require__(35278);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.js + 1 modules
var react_toastify_esm = __webpack_require__(40782);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/assets/images/white-logo.png
/* harmony default export */ var white_logo = ({"src":"/_next/static/media/white-logo.4e755a79.png","height":1868,"width":3695,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAADFBMVEX////////////////1pQ5zAAAABHRSTlMCLApB0/mIGQAAAAlwSFlzAAAuIwAALiMBeKU/dgAAABxJREFUCJljYIABJmZmRmZmRgYGJkYwgAgyAUkAAhwAHW5TiWIAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/styles/footer.module.scss
var footer_module = __webpack_require__(46194);
var footer_module_default = /*#__PURE__*/__webpack_require__.n(footer_module);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/api/endpoints.ts
var endpoints = __webpack_require__(3557);
// EXTERNAL MODULE: ./src/api/http-client.ts
var http_client = __webpack_require__(55642);
;// CONCATENATED MODULE: ./src/layout/footer.tsx











var Footer = function() {
    var ref = (0,react.useState)(false), showTopBtn = ref[0], setShowTopBtn = ref[1];
    var ref1 = (0,react.useState)([]), footerLink = ref1[0], setFooterLink = ref1[1];
    var ref2 = (0,react.useState)(true), showChatBotIcon = ref2[0], setShowChatBotIcon = ref2[1];
    var loadFooter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.home.footerMenu */.Z.home.footerMenu());
                    case 2:
                        data = _ctx.sent.data;
                        setFooterLink(data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadFooter() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        loadFooter();
        window.addEventListener("scroll", function() {
            if (window.scrollY > 400) {
                setShowTopBtn(true);
            } else {
                setShowTopBtn(false);
            }
        });
    }, []);
    var goToTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    var chatScript = "\n    function loadChatgen() {\n      var a = window.ChatGen || [];\n      if (!a.loaded) {\n        var s = document.createElement('script');\n        s.type = \"text/javascript\";\n        s.async = true;\n        s.src = 'https://app.chatgen.ai/cmp/chat-widget/bot.js';\n        var fs = document.getElementsByTagName('script')[0];\n        fs.parentNode.insertBefore(s, fs);\n        s.onload=function(){\n          var yourKey = '0283yMvV';\n          var widgetKey = {widget_key: yourKey};\n          ChatGen.init(widgetKey);\n          ChatGen.startInteraction({ interactionId:542967 });\n          \n        }\n      }\n    };\n    window.loadChatgen = loadChatgen;\n  ";
    var loadChat = function() {
        if (window.loadChatgen) {
            window.loadChatgen();
            setTimeout(function() {
                setShowChatBotIcon(false);
            }, 3000);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "chatgen-script",
                strategy: "afterInteractive",
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: chatScript
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_module_default()).footer_desktop,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    className: "footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (footer_module_default()).footer_bottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row align-items-center",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-4 col-lg-5",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: white_logo,
                                                    alt: "Footer Logo",
                                                    className: "img-fluid",
                                                    width: 231,
                                                    height: 76
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-md-8 col-lg-7 pb-3",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "d-flex justify-content-end w-100 align-items-center footer-top-important-img",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pe-3",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: {
                                                                    // height: 70,
                                                                    // width: 120,
                                                                    position: "relative"
                                                                },
                                                                className: (footer_module_default()).iso,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/vp6GXIFHTzGoNbZiWfgEPGiMWb7FtgwX8rZE8lXV.jpeg",
                                                                    alt: "Footer Logo",
                                                                    className: "img-fluid",
                                                                    width: 150,
                                                                    height: 40
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "pe-3",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                style: {
                                                                    height: 90,
                                                                    width: 60,
                                                                    position: "relative"
                                                                }
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_module_default()).footer_bottom_link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: footerLink.map(function(v, ind) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-3 col-md-4 col-12 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (footer_module_default()).footer_links,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: v.url,
                                                                    passHref: true,
                                                                    children: v.name
                                                                })
                                                            })
                                                        })
                                                    })
                                                }, ind);
                                            })
                                        })
                                    }),
                                    showTopBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_module_default()).go_to_top,
                                        onClick: goToTop,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "bi bi-capslock-fill"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "ps-2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_module_default()).copyright,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "\xa9 ",
                                                new Date().getFullYear(),
                                                " \xa0",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: "Senco Global Jewellery Trading LLC. All Rights Reserved."
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_module_default()).footer_mobile,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                    className: "footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (footer_module_default()).footer_bottom,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "row",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-md-12 pb-3 text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: white_logo,
                                                alt: "Footer Logo",
                                                className: "img-fluid mx-auto",
                                                width: 231,
                                                height: 76
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_module_default()).footer_bottom_link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "row",
                                            children: footerLink.map(function(v, ind) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-lg-3 col-md-6 col-6 ",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (footer_module_default()).footer_links,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: v.url,
                                                                    passHref: true,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        children: v.name
                                                                    })
                                                                })
                                                            })
                                                        })
                                                    })
                                                }, ind);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (footer_module_default()).copyright,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                children: [
                                                    "\xa9 ",
                                                    new Date().getFullYear(),
                                                    " \xa0",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Senco Global Jewellery Trading LLC. All Rights Reserved."
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-md-12 col-lg-5",
                                            children: [
                                                showTopBtn && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (footer_module_default()).go_to_top,
                                                    onClick: goToTop,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "bi bi-capslock-fill"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (footer_module_default()).copyright,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "d-flex justify-content-center align-items-center"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            className: (footer_module_default()).credits,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                    src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/website/files/vp6GXIFHTzGoNbZiWfgEPGiMWb7FtgwX8rZE8lXV.jpeg",
                                                                    alt: " Logo",
                                                                    className: "img-fluid",
                                                                    width: 150,
                                                                    height: 36
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "d-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (footer_module_default()).inerpage_footer,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "row mb-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-md-12 mt-3",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (footer_module_default()).social_links,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "twitter",
                                                href: "#",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    viewBox: "0 0 16 16",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                                        d: "M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "facebook",
                                                href: "#",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-facebook"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "instagram",
                                                href: "#",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-youtube"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "google-plus",
                                                href: "#",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-instagram"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "linkedin",
                                                href: "#",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "bi bi-whatsapp"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("hr", {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var footer = (Footer);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./src/layout/header/middle-bar/MiddleBar.module.scss
var MiddleBar_module = __webpack_require__(87142);
var MiddleBar_module_default = /*#__PURE__*/__webpack_require__.n(MiddleBar_module);
// EXTERNAL MODULE: ./src/lib/fpixel.ts
var fpixel = __webpack_require__(50634);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/layout/header/middle-bar/search-box/SearchBox.tsx






var SearchBox = function() {
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), search = ref[0], setSearch = ref[1];
    (0,react.useEffect)(function() {
        if (router.query.q) {
            setSearch(router.query.q);
        } else {
            setSearch("");
        }
    }, [
        router.query
    ]);
    var searchSubmit = function(e) {
        e.preventDefault();
        if (search.trim()) {
            (0,fpixel/* fbqTrackEvent */.dK)("Search", {
                search_string: search
            });
            router.replace({
                pathname: "/jewellery",
                query: {
                    q: search
                }
            }, undefined, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (MiddleBar_module_default()).search,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: (MiddleBar_module_default()).search_form,
                onSubmit: searchSubmit,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        type: "text",
                        placeholder: "SEARCH",
                        value: search,
                        onChange: function(e) {
                            return setSearch(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        role: "button",
                        "aria-label": "Search button",
                        className: (MiddleBar_module_default()).search_button,
                        type: "submit",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (MiddleBar_module_default()).icon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "img-fluid",
                                src: __webpack_require__(27573),
                                alt: "alt",
                                priority: true,
                                unoptimized: true
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var search_box_SearchBox = (SearchBox);

;// CONCATENATED MODULE: ./src/assets/images/squiggly-arrow.png
/* harmony default export */ var squiggly_arrow = ({"src":"/_next/static/media/squiggly-arrow.985d283b.png","height":48,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEVMaXFta2twbm5ubGxtbGx4dnZzcnKx71oOAAAAB3RSTlMAKIgKRXXPf3JrjQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUCJljYMAGmJlYIAxGNiYQxcLKysQM5jMygmkMAAAGVgAsG4ZqGQAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/assets/images/SencoLogomain.png
/* harmony default export */ var SencoLogomain = ({"src":"/_next/static/media/SencoLogomain.0a71f6df.png","height":930,"width":2347,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEXaR03OOD7XNj7bTFLYP0XYPkXVOUDSIirdV13gYmjkxKMgAAAACHRSTlP7qYr4qfWfU4dtkQ0AAAAJcEhZcwAALiMAAC4jAXilP3YAAAAhSURBVAiZBcGBAQAwCMKw4pTh/w+bMLwBiuySpLAluf8BBNsAZBVxXVcAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(89936);
// EXTERNAL MODULE: ./src/store/slices/auth.ts
var auth = __webpack_require__(40034);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 14 modules
var swiper_react = __webpack_require__(88494);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(71911);
// EXTERNAL MODULE: ./src/store/slices/cart.ts
var cart = __webpack_require__(45066);
// EXTERNAL MODULE: ./src/store/slices/wishlist.ts
var wishlist = __webpack_require__(78271);
// EXTERNAL MODULE: ./src/components/common/currency-inr.tsx
var currency_inr = __webpack_require__(76630);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 68 modules
var esm = __webpack_require__(1485);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Dropdown.js + 11 modules
var Dropdown = __webpack_require__(88545);
;// CONCATENATED MODULE: ./src/layout/header/middle-bar/MiddleBar.tsx


























swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var MiddleBar = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref, ref1;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    // const [isHovered, setIsHovered] = useState(false);
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(""), search = ref2[0], setSearch = ref2[1];
    var ref3 = (0,react.useState)(false), loadbox = ref3[0], setLoadbox = ref3[1];
    var ref4 = (0,react.useState)(false), imgbox = ref4[0], setImgbox = ref4[1];
    var ref5 = (0,react.useState)(null), searchData = ref5[0], setSearchData = ref5[1];
    var debouncedValue = (0,esm/* useDebounce */.Nr)(search, 500);
    var newRef = (0,react.useRef)(null);
    var handleOutsideClick = function(e) {
        //@ts-ignore
        if (newRef.current && !newRef.current.contains(e.target)) {
            setLoadbox(false);
        }
    };
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!((value === null || value === void 0 ? void 0 : value.length) && loadbox)) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return http_client/* default.post */.Z.post(endpoints/* default.products.autoComplete */.Z.products.autoComplete(), {
                            q: value,
                            productsCount: 5,
                            sort: JSON.stringify([
                                {
                                    field: "relevance",
                                    order: "asc"
                                },
                                {
                                    field: "sellingPrice",
                                    order: "asc"
                                }, 
                            ])
                        }, {
                            headers: {
                                "x-store-id": "".concat("fcd453ae559911f0a5630a0c8095feae"),
                                "x-api-key": "".concat("ZXMyckJBSzZhVkcrbm5iVEdFbXl2N2NMamdlOUlDTi9wV1ZNSkpZWFZBdEUyMStOeVQ2MjRYa3FoNDlqcmdGRmtZMUNXVll2U3ZtUmlqMmFTVG5DQ2c9PQ==")
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        setSearchData(data.payload);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        setSearchData(null);
                    case 11:
                        _ctx.next = 14;
                        break;
                    case 13:
                        {
                            setSearchData(null);
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function fetchData(value) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchData(debouncedValue);
        document.addEventListener("mousedown", handleOutsideClick);
        return function() {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedValue
    ]);
    (0,react.useEffect)(function() {
        if (router.query.q) {
            setSearch(router.query.q);
        } else {
            setSearch("");
        }
        setLoadbox(false);
    }, [
        router.query
    ]);
    // useEffect(() => {
    //   setIsHovered(true);
    // }, []);
    var searchSubmit = function(e) {
        e.preventDefault();
        if (search.trim()) {
            (0,fpixel/* fbqTrackEvent */.dK)("Search", {
                search_string: search
            });
            router.replace({
                pathname: "/jewellery",
                query: {
                    q: search
                }
            }, undefined, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container d-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MiddleBar_module_default()).header_logo_section,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MiddleBar_module_default()).w_60,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (MiddleBar_module_default()).header_icon_box,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (MiddleBar_module_default()).header_icon,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "img-fluid pointer",
                                                    src: __webpack_require__(1360),
                                                    alt: "Logo",
                                                    priority: true,
                                                    unoptimized: true,
                                                    width: 167,
                                                    height: 56
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (MiddleBar_module_default()).logo,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "img-fluid pointer",
                                                src: __webpack_require__(79138),
                                                alt: "Logo",
                                                priority: true,
                                                unoptimized: true
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(search_box_SearchBox, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "".concat((MiddleBar_module_default()).main_header),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (MiddleBar_module_default()).header_container,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MiddleBar_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: SencoLogomain,
                                            alt: "Brand Logo",
                                            priority: true
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (MiddleBar_module_default()).search,
                                ref: newRef,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: (MiddleBar_module_default()).search_form,
                                        onSubmit: searchSubmit,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "text",
                                                placeholder: "SEARCH",
                                                value: search,
                                                onChange: function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                                        return runtime_default().wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    setSearch(e.target.value);
                                                                    setLoadbox(true);
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    }));
                                                    return function(e) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }()
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                role: "button",
                                                "aria-label": "Search",
                                                className: (MiddleBar_module_default()).search_button,
                                                type: "submit",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (MiddleBar_module_default()).icon,
                                                    onClick: function() {
                                                        setSearchData(null);
                                                        setLoadbox(false);
                                                        setSearch("");
                                                    },
                                                    children: !search.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "img-fluid",
                                                        src: __webpack_require__(57750),
                                                        alt: "Search icon",
                                                        priority: true,
                                                        unoptimized: true
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "".concat((MiddleBar_module_default()).crosss, " ", "img-fluid"),
                                                        src: __webpack_require__(92820),
                                                        alt: "Cross icon",
                                                        priority: true,
                                                        unoptimized: true
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    searchData && loadbox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (MiddleBar_module_default()).suggestions,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-md-12",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (MiddleBar_module_default()).suggestions_section_header,
                                                            children: "Categories"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: searchData && (searchData === null || searchData === void 0 ? void 0 : (ref = searchData.categories) === null || ref === void 0 ? void 0 : ref.map(function(v) {
                                                                var ref, ref1, ref2;
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                        onClick: function() {
                                                                            var ref, ref1, ref2;
                                                                            router.push({
                                                                                pathname: "/jewellery/category/".concat((ref2 = (ref1 = (ref = v.payload) === null || ref === void 0 ? void 0 : ref.find(function(x) {
                                                                                    return x.key === "relatedCategories";
                                                                                })) === null || ref1 === void 0 ? void 0 : ref1.value.reverse()[0].url) === null || ref2 === void 0 ? void 0 : ref2.split("/jewellery/category/")[1])
                                                                            });
                                                                            setSearchData(null);
                                                                            return;
                                                                        },
                                                                        style: {
                                                                            cursor: "pointer"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                            children: [
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: ((ref1 = (ref = v.payload) === null || ref === void 0 ? void 0 : ref.find(function(x) {
                                                                                        return x.key === "relatedCategories";
                                                                                    })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.value) === null || ref2 === void 0 ? void 0 : ref2.map(function(x) {
                                                                                        return x.name;
                                                                                    }).join(" > ")) || v.value
                                                                                }),
                                                                                " ",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                    className: "span",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: squiggly_arrow,
                                                                                            alt: "Search Icon"
                                                                                        }),
                                                                                        " "
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                });
                                                            }))
                                                        }),
                                                        (searchData === null || searchData === void 0 ? void 0 : searchData.products) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: (MiddleBar_module_default()).suggestions_section_header,
                                                                    children: "Popular Products"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: (MiddleBar_module_default()).popular_products_search,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: (MiddleBar_module_default()).popular_products,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                                                className: "swiper-navigation-black",
                                                                                spaceBetween: 10,
                                                                                slidesPerView: 3,
                                                                                navigation: {
                                                                                    nextEl: ".arrow_left",
                                                                                    prevEl: ".arrow_right"
                                                                                },
                                                                                children: searchData === null || searchData === void 0 ? void 0 : (ref1 = searchData.products) === null || ref1 === void 0 ? void 0 : ref1.result.map(function(v) {
                                                                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                href: v.url,
                                                                                                passHref: true,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                    target: "_blank",
                                                                                                    rel: "noopener noreferrer",
                                                                                                    className: (MiddleBar_module_default()).swiper_card_border,
                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: (MiddleBar_module_default()).popular_products_card,
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                src: v === null || v === void 0 ? void 0 : v.mainImage,
                                                                                                                alt: v.name,
                                                                                                                height: 103,
                                                                                                                width: 102
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                                children: [
                                                                                                                    v.name,
                                                                                                                    " "
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                                children: [
                                                                                                                    " ",
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                                                                                        value: v.sellingPrice
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                })
                                                                                            })
                                                                                        })
                                                                                    });
                                                                                })
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            "aria-label": "Arrow Left",
                                                                            role: "button",
                                                                            className: "".concat((MiddleBar_module_default()).arrow_left, " ", "arrow_left"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "bi bi-chevron-left"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                            role: "button",
                                                                            "aria-label": "Arrow right",
                                                                            className: "".concat((MiddleBar_module_default()).arrow_right, " ", "arrow_right"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                className: "bi bi-chevron-right"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-md-8"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MiddleBar_module_default()).users_container,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/account/profile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "img-fluid pointer",
                                                            src: __webpack_require__(38215),
                                                            width: 29,
                                                            height: 29,
                                                            alt: "Go to Account",
                                                            priority: true,
                                                            unoptimized: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Account"
                                                        })
                                                    ]
                                                })
                                            })
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                size: "sm"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                onClick: function() {
                                                    dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "img-fluid pointer",
                                                        src: __webpack_require__(38215),
                                                        width: 29,
                                                        height: 29,
                                                        alt: "Login to account",
                                                        priority: true,
                                                        unoptimized: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: "Account"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/wishlist",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "img-fluid pointer",
                                                            src: __webpack_require__(88584),
                                                            alt: "Go to Wishlist",
                                                            width: 29,
                                                            height: 29,
                                                            priority: true,
                                                            unoptimized: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Wishlist"
                                                        }),
                                                        !!wishlistState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (MiddleBar_module_default()).top_card,
                                                            children: wishlistState.items.length
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/cart",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "img-fluid pointer",
                                                            src: __webpack_require__(56994),
                                                            alt: "Go to Cart",
                                                            priority: true,
                                                            unoptimized: true,
                                                            width: 29,
                                                            height: 29
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Cart"
                                                        }),
                                                        !!cartState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (MiddleBar_module_default()).top_card_card,
                                                            children: cartState.items.length
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/store-locator",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            className: "img-fluid pointer",
                                                            src: __webpack_require__(75494),
                                                            alt: "store",
                                                            priority: true,
                                                            unoptimized: true,
                                                            width: 29,
                                                            height: 29
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            children: "Stores"
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (MiddleBar_module_default()).custom_flex,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "tel://97142720530",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        className: "img-fluid pointer",
                                                        src: __webpack_require__(67350),
                                                        alt: "Customer Care",
                                                        width: 21,
                                                        height: 21,
                                                        priority: true,
                                                        unoptimized: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "d-inline",
                                                        children: "+97142720530"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                className: (MiddleBar_module_default()).drop_down_main,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                        className: (MiddleBar_module_default()).drop_price_change,
                                                        id: "dropdown-basic",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "img-fluid pointer",
                                                                src: __webpack_require__(39903),
                                                                alt: "Customer Care",
                                                                width: 30,
                                                                height: 30,
                                                                priority: true,
                                                                unoptimized: true
                                                            }),
                                                            " ",
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "UAE"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Menu */.Z.Menu, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                href: "https://sencogoldanddiamonds.com/",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "img-fluid pointer",
                                                                        src: __webpack_require__(20930),
                                                                        alt: "Customer Care",
                                                                        width: 20,
                                                                        height: 20,
                                                                        priority: true,
                                                                        unoptimized: true
                                                                    }),
                                                                    " ",
                                                                    "\xa0 IND"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                href: "https://sencogoldanddiamonds.us/",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "img-fluid pointer",
                                                                        src: __webpack_require__(22760),
                                                                        alt: "Customer Care",
                                                                        width: 20,
                                                                        height: 20,
                                                                        priority: true,
                                                                        unoptimized: true
                                                                    }),
                                                                    " ",
                                                                    "\xa0 USA"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var middle_bar_MiddleBar = (MiddleBar);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Accordion.js + 7 modules
var Accordion = __webpack_require__(5607);
// EXTERNAL MODULE: ./src/styles/mobile_header.module.scss
var mobile_header_module = __webpack_require__(20679);
var mobile_header_module_default = /*#__PURE__*/__webpack_require__.n(mobile_header_module);
;// CONCATENATED MODULE: ./public/img/search.png
/* harmony default export */ var img_search = ({"src":"/_next/static/media/search.d2b15ff9.png","height":23,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAG1BMVEX////o6OjX19fu7u7T09PHx8e5ubn09PTf398wP7MrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALUlEQVQImS2KQQ4AIAjDOobC/19sRJs06aFQkeKyXFNqqAQcT8jQXjNJ/gVuDg5pAG5edNU8AAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/cart-main.png
/* harmony default export */ var cart_main = ({"src":"/_next/static/media/cart-main.39c57052.png","height":26,"width":26,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAMFBMVEVMaXEvLy8hISEjIyMxMTEsLCwlJSU2NjYpKSkhISEhISFBQUFBQUEeHh4fHx+Tk5OTV9BEAAAAEHRSTlMAWXM+cIOWM0qpsRcn2MELDmdiBgAAAAlwSFlzAAALEwAACxMBAJqcGAAAADhJREFUCJkty8cNwDAMBMHlMUlW6L9cw4DnP+TDTxURYSC1t02wAQwDz7V3LSClNMCPM7/a16niBR3lAO+wX8blAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/headphone.png
/* harmony default export */ var headphone = ({"src":"/_next/static/media/headphone.4d0d77ba.png","height":32,"width":31,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEVMaXFFRUU+Pj4rKytGRkYzMzNTU1M/Pz8xMTExMTFKSkoVFRVcUoTaAAAADHRSTlMAdAowTlYaRSJ6Y0czAPU+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVQImUWKORIAQQiEsFud6///3TLaBAgA1asFkIba4AB0RKSgb/xhz3j2sNs5pmKJDxmUAK3zOo4BAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/assets/images/user.png
/* harmony default export */ var user = ({"src":"/_next/static/media/user.084998da.png","height":29,"width":28,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAIVBMVEUoKCgpKSkqKioxMTFMaXEsLCwpKSksLCwpKSkuLi4hISE+dBZBAAAAC3RSTlN+i1AbAKUWPWwt1tpNnL4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAA2SURBVAiZFctBEsAwCAOxtTGQ5P8P7lR3kUI6FUqWrELjez2is7BpOrGThuUcFuY58Rv+DpUPHrMA4k8FXjEAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/assets/images/wish.png
/* harmony default export */ var wish = ({"src":"/_next/static/media/wish.05571436.png","height":23,"width":25,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAJFBMVEUoKCglJSVMaXFGRkYmJiYlJSU7OzsuLi4mJiYpKSkuLi4sLCxwra/BAAAADHRSTlOfqAASlHcEPGcnTyCCa5vTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVQImQXBhwGAAAzAoDSd6v//CizVXSx8VpgBmqlwrXqNdfoiGvuEMg6Rzg8XLwC7W2kjJwAAAABJRU5ErkJggg=="});
;// CONCATENATED MODULE: ./src/layout/header/mobile-header/MobileHeader.tsx




























swiper_esm/* default.use */.ZP.use([
    swiper_esm/* Navigation */.W_,
    swiper_esm/* Pagination */.tl
]);
var MobileHeader = function(param) {
    var menus = param.menus;
    var ref, ref1, ref2;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var ref3 = (0,react.useState)(false), navOpen = ref3[0], setNavOpen = ref3[1];
    var ref4 = (0,react.useState)(false), searchOpen = ref4[0], setSearchOpen = ref4[1];
    var router = (0,next_router.useRouter)();
    var ref5 = (0,react.useState)(""), search = ref5[0], setSearch = ref5[1];
    var ref6 = (0,react.useState)(null), searchData = ref6[0], setSearchData = ref6[1];
    var debouncedValue = (0,esm/* useDebounce */.Nr)(search, 500);
    var ref7 = (0,react.useState)(false), loadbox = ref7[0], setLoadbox = ref7[1];
    var ref8 = (0,react.useState)(false), isFixed = ref8[0], setIsFixed = ref8[1];
    var searchSubmit = function(e) {
        e.preventDefault();
        if (search.trim()) {
            (0,fpixel/* fbqTrackEvent */.dK)("Search", {
                search_string: search
            });
            router.replace({
                pathname: "/jewellery",
                query: {
                    q: search
                }
            }, undefined, {
                shallow: true
            });
        }
    };
    var fetchData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(value) {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!((value === null || value === void 0 ? void 0 : value.length) && loadbox)) {
                            _ctx.next = 13;
                            break;
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return http_client/* default.post */.Z.post(endpoints/* default.products.autoComplete */.Z.products.autoComplete(), {
                            q: value,
                            productsCount: 5
                        }, {
                            headers: {
                                "x-store-id": "".concat("fcd453ae559911f0a5630a0c8095feae"),
                                "x-api-key": "".concat("ZXMyckJBSzZhVkcrbm5iVEdFbXl2N2NMamdlOUlDTi9wV1ZNSkpZWFZBdEUyMStOeVQ2MjRYa3FoNDlqcmdGRmtZMUNXVll2U3ZtUmlqMmFTVG5DQ2c9PQ==")
                            }
                        });
                    case 4:
                        data = _ctx.sent.data;
                        setSearchData(data.payload);
                        _ctx.next = 11;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](1);
                        setSearchData(null);
                    case 11:
                        _ctx.next = 14;
                        break;
                    case 13:
                        {
                            setSearchData(null);
                        }
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    8
                ]
            ]);
        }));
        return function fetchData(value) {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        fetchData(debouncedValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        debouncedValue
    ]);
    (0,react.useEffect)(function() {
        if (router.query.q) {
            setSearch(router.query.q);
        } else {
            setSearch("");
        }
        setLoadbox(false);
    }, [
        router.query
    ]);
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (window.scrollY > 130) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "".concat((mobile_header_module_default()).mobile_header_view, "  ").concat((mobile_header_module_default()).fixed),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (mobile_header_module_default()).top_mobile_header,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row align-items-center",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_header_module_default()).buy_icon,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "".concat((mobile_header_module_default()).icon_first, " ").concat((mobile_header_module_default()).flag_dropdown),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default */.Z, {
                                                className: (mobile_header_module_default()).drop_down_main,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Toggle */.Z.Toggle, {
                                                        className: (mobile_header_module_default()).drop_price_change,
                                                        id: "dropdown-basic",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                className: "img-fluid pointer",
                                                                src: __webpack_require__(39903),
                                                                alt: "Customer Care",
                                                                width: 30,
                                                                height: 30,
                                                                priority: true,
                                                                unoptimized: true
                                                            }),
                                                            " ",
                                                            "\xa0",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "UAE"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Menu */.Z.Menu, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                href: "https://sencogoldanddiamonds.com/",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "img-fluid pointer",
                                                                        src: __webpack_require__(20930),
                                                                        alt: "Customer Care",
                                                                        width: 20,
                                                                        height: 20,
                                                                        priority: true,
                                                                        unoptimized: true
                                                                    }),
                                                                    " ",
                                                                    "\xa0 IND"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Dropdown/* default.Item */.Z.Item, {
                                                                href: "https://sencogoldanddiamonds.us/",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        className: "img-fluid pointer",
                                                                        src: __webpack_require__(22760),
                                                                        alt: "Customer Care",
                                                                        width: 20,
                                                                        height: 20,
                                                                        priority: true,
                                                                        unoptimized: true
                                                                    }),
                                                                    " ",
                                                                    "\xa0 USA"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).icon_first,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "tel://97142720530",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: headphone,
                                                        className: "img-fluid",
                                                        alt: "Call us"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).icon_first,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/store-locator",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    className: (mobile_header_module_default()).map_w,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: __webpack_require__(23997),
                                                        className: "img-fluid",
                                                        alt: "Our Store"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).icon_first,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/wishlist",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: wish,
                                                            className: "img-fluid",
                                                            alt: "Wishlist"
                                                        }),
                                                        !!wishlistState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (mobile_header_module_default()).top_card_card,
                                                            children: wishlistState.items.length
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).icon_first,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/cart",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: cart_main,
                                                            className: "img-fluid",
                                                            alt: "cart"
                                                        }),
                                                        !!cartState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (mobile_header_module_default()).top_card_card,
                                                            children: cartState.items.length
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).icon_first,
                                            children: authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: "/account/profile",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        src: user,
                                                        className: "img-fluid",
                                                        alt: "User"
                                                    })
                                                })
                                            }) : authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                                animation: "border",
                                                size: "sm"
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                onClick: function() {
                                                    return dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: user,
                                                    className: "img-fluid",
                                                    alt: "User"
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "".concat((mobile_header_module_default()).down_header),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (mobile_header_module_default()).header_container,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_header_module_default()).nav_icon,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                        "aria-label": "nav Open",
                                        role: "button",
                                        onClick: function() {
                                            return setNavOpen(!navOpen);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_header_module_default()).middle_logo,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: SencoLogomain,
                                                className: "img-fluid",
                                                alt: "Logo"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (mobile_header_module_default()).search_mobile,
                                    onClick: function() {
                                        return setSearchOpen(!searchOpen);
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: __webpack_require__(27573),
                                        className: "img-fluid",
                                        alt: "search",
                                        priority: true,
                                        unoptimized: true
                                    })
                                }),
                                searchOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                    className: (mobile_header_module_default()).search_box,
                                    onSubmit: searchSubmit,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Search",
                                            value: search,
                                            onChange: function() {
                                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
                                                    return runtime_default().wrap(function _callee$(_ctx) {
                                                        while(1)switch(_ctx.prev = _ctx.next){
                                                            case 0:
                                                                setSearch(e.target.value);
                                                                setLoadbox(true);
                                                            case 2:
                                                            case "end":
                                                                return _ctx.stop();
                                                        }
                                                    }, _callee);
                                                }));
                                                return function(e) {
                                                    return _ref.apply(this, arguments);
                                                };
                                            }()
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                            role: "button",
                                            "aria-label": "Search data",
                                            className: (mobile_header_module_default()).search_button,
                                            type: "submit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_header_module_default()).icon,
                                                onClick: function() {
                                                    setSearchData(null);
                                                    setLoadbox(false);
                                                    setSearch("");
                                                },
                                                children: !search.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "img-fluid",
                                                    src: __webpack_require__(57750),
                                                    alt: "search",
                                                    priority: true,
                                                    unoptimized: true
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    className: "".concat((mobile_header_module_default()).crosss, " ", "img-fluid"),
                                                    src: __webpack_require__(92820),
                                                    alt: "cross",
                                                    priority: true,
                                                    unoptimized: true
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                }),
                navOpen && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (mobile_header_module_default()).slide_nav,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (mobile_header_module_default()).user_profile,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (mobile_header_module_default()).User_images,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                className: "img-fluid",
                                                src: __webpack_require__(59620),
                                                alt: "Logo",
                                                priority: true
                                            })
                                        }),
                                        authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/account/profile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                children: (ref = authState.user) === null || ref === void 0 ? void 0 : ref.name.split(" ")[0]
                                            })
                                        }) : authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                                            animation: "border",
                                            size: "sm"
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            onClick: function() {
                                                return dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                                            },
                                            children: "Login/Register"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                            className: (mobile_header_module_default()).accordion,
                                            defaultActiveKey: "",
                                            children: menus.map(function(v, i) {
                                                return !!v.children.length && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                    className: (mobile_header_module_default()).accordion_item,
                                                    eventKey: i + "_" + v.name,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: v.url,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    target: v.target == "new" ? "_blank" : "_self",
                                                                    onClick: function() {
                                                                        return setNavOpen(!navOpen);
                                                                    },
                                                                    children: v.name
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                            className: (mobile_header_module_default()).accordion_body,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                                                                className: (mobile_header_module_default()).accordion,
                                                                defaultActiveKey: "",
                                                                children: v.children.map(function(x, i) {
                                                                    return !!x.children.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default.Item */.Z.Item, {
                                                                        className: (mobile_header_module_default()).accordion_item_secle,
                                                                        eventKey: x + "_" + x.name,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Header */.Z.Header, {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: x.url,
                                                                                    passHref: true,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        onClick: function() {
                                                                                            return setNavOpen(!navOpen);
                                                                                        },
                                                                                        children: x.name
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default.Body */.Z.Body, {
                                                                                className: (mobile_header_module_default()).accordion_body,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                    children: x.children.map(function(j, idx) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                                href: j.url,
                                                                                                passHref: true,
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                                    onClick: function() {
                                                                                                        return setNavOpen(!navOpen);
                                                                                                    },
                                                                                                    children: j.name
                                                                                                })
                                                                                            })
                                                                                        }, idx);
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }, x + "_" + x.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                        className: "user_accordian",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: x.url,
                                                                                passHref: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    onClick: function() {
                                                                                        return setNavOpen(!navOpen);
                                                                                    },
                                                                                    children: x.name
                                                                                })
                                                                            })
                                                                        }, i + "_" + x.name)
                                                                    });
                                                                })
                                                            })
                                                        })
                                                    ]
                                                });
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                            className: (mobile_header_module_default()).nav_2,
                                            children: menus.map(function(v, i) {
                                                return v.children.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: v.url,
                                                        passHref: true,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            target: v.target == "new" ? "_blank" : "_self",
                                                            onClick: function() {
                                                                return setNavOpen(!navOpen);
                                                            },
                                                            className: "".concat(v.name == "Sencoverse" ? "animation-text" : ""),
                                                            children: v.name
                                                        })
                                                    })
                                                }, i + "_" + v.name);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (mobile_header_module_default()).overlay,
                            onClick: function() {
                                return setNavOpen(false);
                            }
                        })
                    ]
                }),
                searchData && loadbox && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (mobile_header_module_default()).suggestions,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "col-md-12",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (mobile_header_module_default()).suggestions_section_header,
                                        children: "Categories"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        children: searchData && (searchData === null || searchData === void 0 ? void 0 : (ref1 = searchData.categories) === null || ref1 === void 0 ? void 0 : ref1.map(function(v) {
                                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                    onClick: function() {
                                                        var ref, ref1, ref2;
                                                        router.push({
                                                            pathname: "/jewellery/category/".concat((ref2 = (ref1 = (ref = v.payload) === null || ref === void 0 ? void 0 : ref.find(function(x) {
                                                                return x.key === "relatedCategories";
                                                            })) === null || ref1 === void 0 ? void 0 : ref1.value.reverse()[0].url) === null || ref2 === void 0 ? void 0 : ref2.split("/jewellery/category/")[1])
                                                        });
                                                        setSearchData(null);
                                                        return;
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        children: [
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                children: [
                                                                    v.value,
                                                                    " "
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                className: "span",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                        src: img_search,
                                                                        alt: ""
                                                                    }),
                                                                    " "
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            });
                                        }))
                                    }),
                                    (searchData === null || searchData === void 0 ? void 0 : searchData.products) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (mobile_header_module_default()).suggestions_section_header,
                                                children: "Popular Products"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (mobile_header_module_default()).popular_products_search,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (mobile_header_module_default()).popular_products,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                                                            className: "swiper-navigation-black",
                                                            spaceBetween: 10,
                                                            slidesPerView: 2,
                                                            navigation: {
                                                                nextEl: ".image-swiper-button-next",
                                                                prevEl: ".image-swiper-button-prev"
                                                            },
                                                            children: searchData === null || searchData === void 0 ? void 0 : (ref2 = searchData.products) === null || ref2 === void 0 ? void 0 : ref2.result.map(function(v) {
                                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: v.url,
                                                                            passHref: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                target: "_blank",
                                                                                rel: "noopener noreferrer",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: (mobile_header_module_default()).popular_products_card,
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            src: v === null || v === void 0 ? void 0 : v.mainImage,
                                                                                            alt: "",
                                                                                            height: 103,
                                                                                            width: 102
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                            children: [
                                                                                                v.name,
                                                                                                " "
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                            children: [
                                                                                                " ",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(currency_inr/* default */.Z, {
                                                                                                    value: v.sellingPrice
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        })
                                                                    })
                                                                });
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        role: "button",
                                                        "aria-label": "button next",
                                                        className: "".concat((mobile_header_module_default()).arrow_left, " ", "image-swiper-button-next"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-chevron-left"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                        "aria-label": "button prev",
                                                        role: "button",
                                                        className: "".concat((mobile_header_module_default()).arrow_right, " ", "image-swiper-button-prev"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "bi bi-chevron-right"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-md-8"
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var mobile_header_MobileHeader = (MobileHeader);

// EXTERNAL MODULE: ./src/styles/navbar.module.scss
var navbar_module = __webpack_require__(64891);
var navbar_module_default = /*#__PURE__*/__webpack_require__.n(navbar_module);
;// CONCATENATED MODULE: ./src/layout/header/nav-bar/NavBar.tsx





var NavBar = function(param) {
    var menus = param.menus;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((navbar_module_default()).main_nav),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: (navbar_module_default()).nav2,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: (navbar_module_default()).main_menu,
                        children: menus.map(function(v, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                        className: (navbar_module_default()).li,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                href: v.url,
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                    className: "".concat(v.name == "Sencoverse" ? "animation-text" : ""),
                                                    target: v.target == "new" ? "_blank" : "_self",
                                                    children: [
                                                        v.name,
                                                        v.tags.includes("new") && /*#__PURE__*/ (0,jsx_runtime.jsx)("sup", {
                                                            className: "top_new",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                src: "https://sencowebfiles.s3.ap-south-1.amazonaws.com/menu-new.png",
                                                                alt: "New",
                                                                layout: "fill",
                                                                priority: true
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            !!v.children.length && v.type === "mega1" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (navbar_module_default()).fw_dropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (navbar_module_default()).nav_container,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (navbar_module_default()).dropdown_column_list_2,
                                                        children: v.children.map(function(j, idx) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                        href: j.url,
                                                                        passHref: true,
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: (navbar_module_default()).dropdown_header_text,
                                                                                children: j.name
                                                                            })
                                                                        })
                                                                    }),
                                                                    j.children.map(function(x, indxx) {
                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                href: x.url,
                                                                                passHref: true,
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                    className: (navbar_module_default()).last_link,
                                                                                    children: x.name
                                                                                })
                                                                            })
                                                                        }, indxx + "_" + x.name);
                                                                    })
                                                                ]
                                                            }, idx + "_" + j.name);
                                                        })
                                                    })
                                                })
                                            }),
                                            !!v.children.length && v.type === "mega2" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (navbar_module_default()).fw_dropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((navbar_module_default()).nav_container, " ").concat((navbar_module_default()).large_height_second_level),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (navbar_module_default()).dropdown_column_list_2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: v.children.map(function(j, idx) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: j.url,
                                                                            passHref: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (navbar_module_default()).dropdown_header_text,
                                                                                    children: j.name
                                                                                })
                                                                            })
                                                                        }),
                                                                        j.children.map(function(x, indxx) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: x.url,
                                                                                    passHref: true,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        className: (navbar_module_default()).last_link,
                                                                                        children: x.name
                                                                                    })
                                                                                })
                                                                            }, indxx + "_" + x.name);
                                                                        })
                                                                    ]
                                                                }, idx + "_" + j.name);
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            !!v.children.length && v.type === "mega6" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (navbar_module_default()).fw_dropdown,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "".concat((navbar_module_default()).nav_container, " ").concat((navbar_module_default()).large_height_third_level),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (navbar_module_default()).dropdown_column_list_2,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                            children: v.children.map(function(j, idx) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                            href: j.url,
                                                                            passHref: true,
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: (navbar_module_default()).dropdown_header_text,
                                                                                    children: j.name
                                                                                })
                                                                            })
                                                                        }),
                                                                        j.children.map(function(x, indxx) {
                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: x.url,
                                                                                    passHref: true,
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                                        className: (navbar_module_default()).last_link,
                                                                                        children: x.name
                                                                                    })
                                                                                })
                                                                            }, indxx + "_" + x.name);
                                                                        })
                                                                    ]
                                                                }, idx + "_" + j.name);
                                                            })
                                                        })
                                                    })
                                                })
                                            }),
                                            !!v.children.length && v.type === "mega4" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: (navbar_module_default()).fw_dropdown3,
                                                    children: v.children.map(function(j, idx) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                href: j.url,
                                                                passHref: true,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                    children: j.name
                                                                })
                                                            })
                                                        }, idx + "_" + j.name);
                                                    })
                                                })
                                            })
                                        ]
                                    }, i + "_" + v.name)
                                ]
                            });
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var nav_bar_NavBar = (NavBar);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/data/header.ts
var headerTopLeftLinks = [
    {
        props: {
            href: "https://wa.me/7605023222",
            target: "_blank",
            rel: "noopener noreferrer"
        },
        image: __webpack_require__(23024),
        alt: "WhatsApp Icon",
        label: "7605023222"
    },
    {
        props: {
            href: "tel://97142720530"
        },
        image: __webpack_require__(14842),
        alt: "Phone Icon",
        label: "+97142720530"
    },
    {
        props: {
            href: "/store-locator"
        },
        image: __webpack_require__(23997),
        alt: "Map Icon",
        label: "Find Store"
    }, 
];

// EXTERNAL MODULE: ./src/layout/header/top-bar/TopBar.module.scss
var TopBar_module = __webpack_require__(2228);
var TopBar_module_default = /*#__PURE__*/__webpack_require__.n(TopBar_module);
;// CONCATENATED MODULE: ./src/layout/header/top-bar/left-links/LeftLinks.tsx







var LeftLinks = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
            className: (TopBar_module_default()).navlist1,
            children: headerTopLeftLinks.map(function(link, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (TopBar_module_default()).navitem1,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, link.props), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: link.image,
                                alt: link.alt,
                                priority: true,
                                unoptimized: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: link.label
                            })
                        ]
                    }))
                }, index);
            })
        })
    });
};
/* harmony default export */ var left_links_LeftLinks = (LeftLinks);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Badge.js
var Badge = __webpack_require__(27977);
;// CONCATENATED MODULE: ./src/layout/header/top-bar/right-links/RightLinks.tsx










var RightLinks = function() {
    var ref;
    var dispatch = (0,store/* useAppDispatch */.T)();
    var authState = (0,es/* useSelector */.v9)(auth/* selectAuth */.Hz);
    var cartState = (0,es/* useSelector */.v9)(cart/* selectCart */.KY);
    var wishlistState = (0,es/* useSelector */.v9)(wishlist/* selectWishlist */.jq);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
            className: (TopBar_module_default()).nav_list,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (TopBar_module_default()).nav_item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/wishlist",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "bi bi-heart"
                                }),
                                !!wishlistState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    className: (TopBar_module_default()).cart_item,
                                    pill: true,
                                    bg: "light",
                                    text: "dark",
                                    children: wishlistState.items.length
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (TopBar_module_default()).nav_item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/cart",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "bi bi-cart"
                                }),
                                !!cartState.items.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge/* default */.Z, {
                                    className: (TopBar_module_default()).cart_item,
                                    pill: true,
                                    bg: "light",
                                    text: "dark",
                                    children: cartState.items.length
                                })
                            ]
                        })
                    })
                }),
                authState.user ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (TopBar_module_default()).nav_item,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/account/profile",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                    className: "bi bi-person-circle me-2"
                                }),
                                (ref = authState.user) === null || ref === void 0 ? void 0 : ref.name.split(" ")[0]
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (TopBar_module_default()).nav_item,
                    children: authState.isUserLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        animation: "border",
                        size: "sm"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        onClick: function() {
                            return dispatch(auth/* authActions.setIsModalOpen */.YV.setIsModalOpen(true));
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "bi bi-person-circle me-2"
                            }),
                            "Login/Register"
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var right_links_RightLinks = (RightLinks);

;// CONCATENATED MODULE: ./src/layout/header/top-bar/TopBar.tsx





var TopBar = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
            className: (TopBar_module_default()).nav,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-md-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (TopBar_module_default()).topbar,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(left_links_LeftLinks, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(right_links_RightLinks, {})
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var top_bar_TopBar = (TopBar);

;// CONCATENATED MODULE: ./src/layout/header/Header.tsx












var Header = function() {
    var ref = (0,react.useState)([
        {
            url: "/jewellery/category/diamond-jewellery",
            name: "Diamond"
        },
        {
            url: "/jewellery/category/gold-jewellery",
            name: "Gold"
        },
        {
            url: "/jewellery/category/platinum-jewellery",
            name: "Platinum"
        },
        {
            url: "#",
            name: "Collections"
        },
        {
            url: "https://sencogoldanddiamonds.com/gifts/",
            name: "Gifts"
        },
        {
            url: "/gift-card",
            name: "Gift Cards"
        },
        {
            url: "/jewellery/category/coins-and-bars",
            name: "Coins, Bars & Beans"
        },
        {
            url: "https://everlite.com",
            name: "Everlite"
        },
        {
            url: "/house-of-senco",
            name: "House of Senco"
        },
        {
            url: "https://www.sencoverse.com",
            name: "Sencoverse"
        },
        {
            url: "/astro",
            name: "Astro"
        },
        {
            url: "#",
            name: "Others"
        }, 
    ].map(function(v) {
        return (0,_object_spread/* default */.Z)({
            tags: [],
            type: "link",
            target: "same",
            children: []
        }, v);
    })), data = ref[0], setData = ref[1];
    var ref1 = (0,react.useState)(false), isFixed = ref1[0], setIsFixed = ref1[1];
    (0,react.useEffect)(function() {
        loadMenu();
    }, []);
    var loadMenu = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var data;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return http_client/* default.get */.Z.get(endpoints/* default.home.menu */.Z.home.menu());
                    case 2:
                        data = _ctx.sent.data;
                        setData(data);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function loadMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        var handleScroll = function() {
            if (window.scrollY > 150) {
                setIsFixed(true);
            } else {
                setIsFixed(false);
            }
        };
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_TopBar, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((navbar_module_default()).fixed, " ").concat((navbar_module_default()).w_100),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(middle_bar_MiddleBar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(nav_bar_NavBar, {
                            menus: data
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (navbar_module_default()).nav_height
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_header_MobileHeader, {
                    menus: data
                })
            ]
        })
    });
};
/* harmony default export */ var header_Header = (Header);

// EXTERNAL MODULE: ./src/components/auth/sccount-selection-modal.tsx
var sccount_selection_modal = __webpack_require__(95117);
// EXTERNAL MODULE: ./src/components/auth/customer-consent.tsx + 1 modules
var customer_consent = __webpack_require__(54179);
// EXTERNAL MODULE: ./src/components/auth/billing-address-modal.tsx
var billing_address_modal = __webpack_require__(29543);
;// CONCATENATED MODULE: ./src/layout/layout.tsx













var Layout = function(param) {
    var children = param.children;
    var helmet = (0,es/* useSelector */.v9)(slices_helmet/* selectHelmet */.ZZ);
    var commonTitle = (0,react.useMemo)(function() {
        if (helmet.ignoreCommonTitle) {
            return "";
        }
        if (helmet.title) {
            return " | " + helmet.commonTitle;
        }
        return "";
    }, [
        helmet
    ]);
    var pageTitle = (0,react.useMemo)(function() {
        return "".concat(helmet.title).concat(commonTitle);
    }, [
        helmet,
        commonTitle
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "/favicon.ico"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: pageTitle
                    }),
                    (helmet === null || helmet === void 0 ? void 0 : helmet.path) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: "".concat("https://sencogoldanddiamonds.ae").concat(helmet.path)
                        })
                    }),
                    (helmet === null || helmet === void 0 ? void 0 : helmet.meta) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "title",
                                content: helmet.meta.title || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "description",
                                content: helmet.meta.description || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                name: "keywords",
                                content: helmet.meta.keywords || ""
                            })
                        ]
                    }),
                    (helmet === null || helmet === void 0 ? void 0 : helmet.og) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:type",
                                content: helmet.og.type || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:url",
                                content: helmet.og.url || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:title",
                                content: helmet.og.title || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:description",
                                content: helmet.og.description || ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                                property: "og:image",
                                content: helmet.og.image || ""
                            })
                        ]
                    }),
                    !!(helmet === null || helmet === void 0 ? void 0 : helmet.schema) && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: helmet.schema
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(header_Header, {}),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(auth_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(billing_address_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(offer_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(sccount_selection_modal/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(customer_consent/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {
                autoClose: 2000,
                theme: "colored",
                newestOnTop: true,
                position: "top-center"
            })
        ]
    });
};
/* harmony default export */ var layout = (Layout);


/***/ }),

/***/ 87142:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header_logo_section":"MiddleBar_header_logo_section__uCgX3","w_60":"MiddleBar_w_60__nogbQ","header_icon_box":"MiddleBar_header_icon_box__hqZYn","header_icon":"MiddleBar_header_icon__s1mkf","header_text":"MiddleBar_header_text__C2CJk","logo":"MiddleBar_logo__gMyci","search":"MiddleBar_search__4JBB1","search_form":"MiddleBar_search_form__zy3Q5","search_button":"MiddleBar_search_button__Fcenc","typed":"MiddleBar_typed__mWO7e","icon":"MiddleBar_icon____3K3","clear":"MiddleBar_clear__RbG1L","main_header":"MiddleBar_main_header__mupiU","top-text-topbar":"MiddleBar_top-text-topbar__7Vulr","header_container":"MiddleBar_header_container__cOarq","users_container":"MiddleBar_users_container__HLyNO","top_card":"MiddleBar_top_card__uR_EP","top_card_card":"MiddleBar_top_card_card__GxU17","custom_flex":"MiddleBar_custom_flex__8SRUv","drop_down_main":"MiddleBar_drop_down_main__QfrLq","drop_price_change":"MiddleBar_drop_price_change__KYQHO","suggestions":"MiddleBar_suggestions__sIQD0","suggestions_section_header":"MiddleBar_suggestions_section_header__iNDAr","span":"MiddleBar_span__ZgRa3","border_contant":"MiddleBar_border_contant__DtZlz","popular_products":"MiddleBar_popular_products__abbZm","popular_products_card":"MiddleBar_popular_products_card__beq3H","swiper_card_border":"MiddleBar_swiper_card_border__Gm_op","popular_products_search":"MiddleBar_popular_products_search__GJW38","swiper-button-next":"MiddleBar_swiper-button-next__GbDse","swiper-button-prev":"MiddleBar_swiper-button-prev__Cvw7Q","arrow_left":"MiddleBar_arrow_left__kpTA_","arrow_right":"MiddleBar_arrow_right__9qOa1","crosss":"MiddleBar_crosss__nZDIn","drop_hover":"MiddleBar_drop_hover__2m_nV","drop_hover_head":"MiddleBar_drop_hover_head__2haNI","drop_card":"MiddleBar_drop_card__YzTxI","visual":"MiddleBar_visual__tYImM","take":"MiddleBar_take__9_rPn"};

/***/ }),

/***/ 2228:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"nav":"TopBar_nav__W0sMn","topbar":"TopBar_topbar__w0Dtn","navlist1":"TopBar_navlist1__Os6LR","navitem1":"TopBar_navitem1__j_sC6","nav_list":"TopBar_nav_list__Hwfki","nav_item":"TopBar_nav_item__F4yb3","cart_item":"TopBar_cart_item__m2TFX"};

/***/ }),

/***/ 46194:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer_desktop":"footer_footer_desktop__BobXE","footer_top_a":"footer_footer_top_a__hNN8T","footer_top":"footer_footer_top___7BO_","footer_top_image":"footer_footer_top_image__ZFDRK","app_logo":"footer_app_logo__s48bY","middle_section":"footer_middle_section__FLoKf","h3":"footer_h3__7KCbN","h4":"footer_h4__MIiyz","border_top_1":"footer_border_top_1__yhmhe","footer_bottom_link":"footer_footer_bottom_link__HfEaC","footer_bottom":"footer_footer_bottom__PFTgG","footer_links":"footer_footer_links__P7E61","copyright":"footer_copyright__1iHZZ","credits":"footer_credits__NrJx4","footer_mobile":"footer_footer_mobile__FAtfk","social_links1":"footer_social_links1__iWtb8","certificationbadge":"footer_certificationbadge__Aof7Y","iso":"footer_iso__sli7C","gpay":"footer_gpay__Ko88M","inerpage_footer":"footer_inerpage_footer__ntZIO","go_to_top":"footer_go_to_top__7HOnO","social_links":"footer_social_links__9dqkk","download":"footer_download__MVXJJ"};

/***/ }),

/***/ 20679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"top_mobile_header":"mobile_header_top_mobile_header__XQYhm","dropdown":"mobile_header_dropdown__t2yl1","dropbtn":"mobile_header_dropbtn__J8JD3","buy_icon":"mobile_header_buy_icon___4fRd","icon_first":"mobile_header_icon_first__uf6iP","top_card":"mobile_header_top_card__3U7EG","top_card_card":"mobile_header_top_card_card__u3_4x","maincart_mobile":"mobile_header_maincart_mobile__HbHfK","down_header":"mobile_header_down_header__Vy3_p","header_container":"mobile_header_header_container__G1IhC","nav_icon":"mobile_header_nav_icon__Ml2em","middle_logo":"mobile_header_middle_logo__p2yR_","search_mobile":"mobile_header_search_mobile__bTuoF","fixed":"mobile_header_fixed__dinLe","slideDown":"mobile_header_slideDown__oIk8Y","slide_nav":"mobile_header_slide_nav__6aCLG","user_profile":"mobile_header_user_profile__93sFd","User_images":"mobile_header_User_images__WRePE","nav_2":"mobile_header_nav_2__ltZ_T","overlay":"mobile_header_overlay__qQl2s","mobile_header_view":"mobile_header_mobile_header_view__SHOsy","search_box":"mobile_header_search_box__NYwaC","map_w":"mobile_header_map_w__mpqIM","suggestions":"mobile_header_suggestions___VWlh","suggestions_section_header":"mobile_header_suggestions_section_header__JywEO","span":"mobile_header_span__WDNbO","border_contant":"mobile_header_border_contant__hIXtB","popular_products":"mobile_header_popular_products__KUkVh","popular_products_card":"mobile_header_popular_products_card__06Yem","accordion_item":"mobile_header_accordion_item__Kpa_N","accordion":"mobile_header_accordion__kxUBb","accordion_body":"mobile_header_accordion_body__Bvrka","accordion_item_secle":"mobile_header_accordion_item_secle__Mbseu","collapsed":"mobile_header_collapsed__yBcP6","accordion-button":"mobile_header_accordion-button__x3_zp","accordion-header":"mobile_header_accordion-header__hS05i","accordion-item":"mobile_header_accordion-item__mjN8W","popular_products_search":"mobile_header_popular_products_search__VCAd_","swiper-button-next":"mobile_header_swiper-button-next__TxmnA","swiper-button-prev":"mobile_header_swiper-button-prev__OQhk8","arrow_left":"mobile_header_arrow_left__W9Bj5","arrow_right":"mobile_header_arrow_right__zJzOC","crosss":"mobile_header_crosss__pDvox","mobile_nav_inerbg_fixe":"mobile_header_mobile_nav_inerbg_fixe__NkCfe","flag_dropdown":"mobile_header_flag_dropdown__97GE5","drop_price_change":"mobile_header_drop_price_change__nVEvl","drop_down_main":"mobile_header_drop_down_main__KfTc3","active_fixe":"mobile_header_active_fixe__rbCc_","nav_height":"mobile_header_nav_height__JhLP8"};

/***/ }),

/***/ 64891:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main_nav":"navbar_main_nav__io4nB","container":"navbar_container__qiWcz","nav_container":"navbar_nav_container__wQwae","large_height_second_level":"navbar_large_height_second_level__HDZai","dropdown_column_list_2":"navbar_dropdown_column_list_2__Eik60","large_height_third_level":"navbar_large_height_third_level__fags6","nav2":"navbar_nav2__t3uSY","main_menu":"navbar_main_menu__t66W_","m-color":"navbar_m-color__mMwUA","fw_dropdown":"navbar_fw_dropdown__YfRR0","text-grey":"navbar_text-grey__kWP1b","explore-btn":"navbar_explore-btn__g7_dA","dropdown-column-list":"navbar_dropdown-column-list__vhQq5","sub_link":"navbar_sub_link__IMbl_","fw_dropdown2":"navbar_fw_dropdown2__t6T7C","dropdown_header_text":"navbar_dropdown_header_text__0Vbhy","last_link":"navbar_last_link__1MDHu","header-img":"navbar_header-img__CXa6E","fw_dropdown3":"navbar_fw_dropdown3__uO3Re","fixed":"navbar_fixed__e4j8O","nav_height":"navbar_nav_height__V2ejS","fixe":"navbar_fixe____lSF","w_100":"navbar_w_100__qBhZ1"};

/***/ })

}]);